var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ReactTranslationContext, useLanguageCode } from '../../core';
import ReactFlagsSelect from 'react-flags-select';
import React, { useContext, useMemo } from 'react';
export const LanguageSelector = (_a) => {
    var { selected = "", countries: sourceCountries, onSelect } = _a, props = __rest(_a, ["selected", "countries", "onSelect"]);
    const [language, setSelected] = useLanguageCode();
    const translation = useContext(ReactTranslationContext);
    const countries = useMemo(() => {
        const countriesList = {};
        if (translation) {
            translation === null || translation === void 0 ? void 0 : translation.languages.forEach((lang) => {
                countriesList[translation.mapToCountryFlag(lang)] = translation.mapToLanguageName(lang);
            });
        }
        return countriesList;
    }, [language, translation]);
    if (language == undefined || translation === undefined || ((translation === null || translation === void 0 ? void 0 : translation.languages) && translation.languages.length <= 1)) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(ReactFlagsSelect, Object.assign({ selected: translation === null || translation === void 0 ? void 0 : translation.mapToCountryFlag(language), countries: Object.keys(countries), customLabels: countries, showSelectedLabel: true, onSelect: code => setSelected === null || setSelected === void 0 ? void 0 : setSelected(translation === null || translation === void 0 ? void 0 : translation.mapFromCountryFlag(code)) }, props));
};
//# sourceMappingURL=index.js.map